var map = {
	"./TEST.json": "8244",
	"./ee.json": "c009",
	"./en.json": "ad10",
	"./fr.json": "9d19",
	"./it.json": "450c",
	"./lt.json": "522e",
	"./lv.json": "b541",
	"./ru.json": "f753"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cce7";